import { render, staticRenderFns } from "./CreateStrategicGoal.vue?vue&type=template&id=3a05a4be&scoped=true"
import script from "./CreateStrategicGoal.vue?vue&type=script&lang=js"
export * from "./CreateStrategicGoal.vue?vue&type=script&lang=js"
import style0 from "./CreateStrategicGoal.vue?vue&type=style&index=0&id=3a05a4be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a05a4be",
  null
  
)

export default component.exports